import { t } from "@/i18n";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loader label={t("getting_your_crayons_ready")} />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
};
